import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteApi, getApi, postApi } from "redux/apis";
export const GetIpWhteList: any = createAsyncThunk(
    "ipWhiteList/get",
    async (paramas: any = {}, { rejectWithValue }) => {
        try {
            const response = await getApi(`/ipWhiteList`, {
                ...paramas,
            });

            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const CreateIpWhteList: any = createAsyncThunk(
    "ipWhiteList/create",
    async (paramas: any = {}, { rejectWithValue }) => {
        try {
            const response = await postApi(`/ipWhiteList`, {
                ...paramas,
            });

            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);
export const DeleteIpWhteList: any = createAsyncThunk(
    "ipWhiteList/delete",
    async (paramas: any = {}, { rejectWithValue }) => {
        try {
            const response = await deleteApi(`/ipWhiteList/${paramas.id}`);

            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);